// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js","682":"component---src-pages-about-js"}[chunkId] + "-" + {"351":"67cfdb7b75050af29586","678":"9b59e40ca4f7152e9628","682":"7fde89774a0864795072"}[chunkId] + ".js";
};